import React from 'react'
import PropTypes from 'prop-types'

const Text = ({ is, children, ...props }) => {
  const Component = is || 'p'

  return <Component {...props}>{children}</Component>
}

Text.propTypes = {
  children: PropTypes.node.isRequired,
  is: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

Text.defaultProps = {
  is: null,
}

export default Text
